export default __webpack_public_path__ + "static/media/projeto5.cec0dc59.PNG";